export const BROWSER_GETTER_URL = 'brower/getter/url';

export const BROWSER_MUTATION_SET_URL = 'browser/mutation/SET_ URL';
